import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "pickable", // all elements that can be shown, they must have a data-index
    "handle", // thumbs that reference a pickable, they must have a data-index
  ]

  choose(e) {
    e.preventDefault()
    const index = e.currentTarget.dataset.index

    this.pickableTargets.forEach(pickable => {
      if (pickable.dataset.index == index) {
        this._showPickable(pickable)
      } else {
        this._hidePickable(pickable)
      }
    })

    this.handleTargets.forEach(handle => {
      if (handle.dataset.index == index) {
        handle.classList.add("is-active")
      } else {
        handle.classList.remove("is-active")
      }
    })
  }

  _showPickable = (element) => {
    element.classList.remove("is-hidden")
  }

  _hidePickable = (element) => {
    if (!element.classList.contains("is-hidden")) {
      element.classList.add("is-hidden")
      element.dispatchEvent(new CustomEvent("picker:hide"))
    }
  }
}
